import { useEffect, useState, useCallback } from "react";
import { useNotifications } from "../../../../context/NotificationContext";
import { useStyles } from "./ChallengeItem";
import {
  View,
  TouchableOpacity,
  Image,
  Text,
  StyleProp,
  ViewStyle,
  TextStyle,
} from "react-native";
import { AppColors } from "../../../../utility/AppColors";
import { StackActions } from "@react-navigation/native";
import { navigateToScreen } from "../../../../utility/NavigationHelper";
import { AppScreens } from "../../../Utility/AppScreens";
import { AppFontStyle } from "../../../../styles/AppFontStyle";
import { AppImages } from "../../../../utility/AppImages";
import { DEVICE_SIZES, useDeviceSize } from "rn-responsive-styles";
import { CommonButton } from "../../../../common/CommonButton";
import { toast } from "react-toastify";
import { base_url, endpoints } from "../../../../Api/configs";
import { fetchUserConnectionStatus } from "../../../../services/stream";
import { getNotificationById } from "../../../../services/notification";
import { confirmAttendance } from "../../../../services/eventsAPI";
import { getLoginData } from "../../../../utility/AppStoreData";
import { useChat } from "../../../../context/ChatContext";
import FinalWarning from "../SaleBeltScreens/FinalWarning";
import { NOTIFICATION_STRINGS } from "../../../../utility/types/stringsConfig";
import { NOTIFICATION_DIMENSIONS } from "../../../../config/notificationConfig";
import React from "react";
import { parseResponseBody } from "../../../../services/apiClient";
import { storeUserActivity, ACTIVITY_TYPES } from "../../../../services/activityService";

export const NotificationButtons = ({
  item,
  navigation,
  selectedButton,
  setShowPendingNotifications,
  setChallengeItem,
  setChallengeID,
  challengeID,
  setShowNotificationDetails,
  accessToken,
  noTimeLeft,
  setConfirmCheckInLoader,
  confirmCheckInLoader,
  getNotificationList,
  setChallengeDetails,
  setUpdatedEventDetails,
  setPreviousEventDetails,
  setUpdatedEventEventId,
  setUpdatedEventNotificationId,
  setShowEventsDetailsUpdatedModal,
  setShowChangesApprovedModal,
  setShowChangesRejectedModal,
  showChangesLoader,
  challengeDetails,
  showAcceptModal,
  setShowAcceptModal,
  setCornfirmPurchaseBeltModal,
  setAcceptLoader,
  handleProfileUpdate,
  isMissed,
  markAsSeenById,
  refreshCounts,
  updateNotificationStatus,
}) => {
  const deviceSize = useDeviceSize();
  const styles = useStyles();
  const { notifications, sendNotification, setUpdateNotification } =
    useNotifications();
  const { chats } = useChat();
  const [processedTimestamps, setProcessedTimestamps] = useState(
    new Set<string>()
  );
  const [userData, setUserData] = useState<any>(null);
  const [finalWarningPopUp, setFinalWarningPopUp] = useState(false);
  const [eventData, setEventData] = useState<any>(null);
  const [platformStatus, setPlatformStatus] = useState({
    YouTube: "Not connected",
    Twitch: "Not connected",
  });
  const [unreadMessages, setUnreadMessages] = useState(
    item.unreadMessages || 0
  );
  const currentUser = localStorage.getItem("username");

  // Helper function to mark notification as seen and refresh counts when user interacts with it
  // This function runs in the background WITHOUT blocking navigation for smooth UX
  const handleMarkAsSeenAndRefreshCounts = useCallback(() => {
    if (item.isSeen === 0 && markAsSeenById) {
      // Fire and forget - don't await, let it run in background
      markAsSeenById(accessToken, item.notificationId)
        .then(() => {
          // Refresh counts after marking as seen
          if (refreshCounts) {
            console.log('🔄 Refreshing all notification counts after user interaction');
            setTimeout(() => refreshCounts(), 300); // Small delay to ensure backend is updated
          }
        })
        .catch((error) => {
          console.error('Failed to mark notification as seen:', error);
        });
    }
  }, [item.isSeen, item.notificationId, markAsSeenById, accessToken, refreshCounts]);

  useEffect(() => {
    const relatedChat = chats.find(
      (chat) => chat.conversationId === item.details?.ChatConversationId
    );
    setUnreadMessages(
      relatedChat ? relatedChat.unreadCount || 0 : item.unreadMessages || 0
    );
  }, [chats, item.details?.ChatConversationId, item.unreadMessages]);

  useEffect(() => {
    const fetchUserData = async () => {
      const data = await getLoginData();
      if (data) setUserData(data);
    };
    fetchUserData();
  }, []);

  useEffect(() => {
    if (challengeID) callGetChallengeDetails(challengeID);
  }, [challengeID]);

  useEffect(() => {
    notifications?.forEach((notification: any) => {
      if (
        notification?.notificationType === "Chat" &&
        notification?.chatId === item.ChatConversationId
      ) {
        if (!processedTimestamps.has(notification?.timestamp)) {
          setProcessedTimestamps((prev) =>
            new Set(prev).add(notification?.timestamp)
          );
          setUnreadMessages((prevCount) => prevCount + 1);
        }
      }
    });
  }, [notifications, processedTimestamps, item.ChatConversationId]);

  const confirmEventCheckInStatus = useCallback(
    async (eventId: string, notificationId: string) => {
      setConfirmCheckInLoader(true);
      try {
        const response = await confirmAttendance(
          accessToken,
          eventId,
          notificationId
        );
        if (response.statusCode === 200) {
          toast.success("Event attendance confirmed successfully");

          // Update the notification status in local state
          if (updateNotificationStatus) {
            updateNotificationStatus(notificationId, {
              actionStatus: "confirmed"
            });
          }
        } else if (response.statusCode === 400 || response.statusCode === 403) {
          toast.error(response.body.error);
        }
      } catch (error) {
        toast.error("Failed to confirm event check-in");
        console.error("Error confirming event check-in:", error);
      } finally {
        setConfirmCheckInLoader(false);
      }
    },
    [accessToken, setConfirmCheckInLoader, updateNotificationStatus]
  );

  const fetchStatus = useCallback(async () => {
    try {
      const response = await fetchUserConnectionStatus(accessToken);
      if (response.statusCode === 200) {
        setPlatformStatus(response.body);
      } else {
        toast.error("Failed to fetch platform connection status.");
      }
    } catch (error) {
      console.error("Error fetching platform status:", error);
      toast.error("Failed to fetch platform connection status.");
    }
  }, [accessToken]);

  const handleAcceptPress = useCallback(
    async (userResponse: boolean, challengeId: string) => {
      setAcceptLoader(true);
      const url = `${base_url}${endpoints.events.challengeRespond}`;
      try {
        const response = await fetch(url, {
          mode: "cors",
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            accessToken,
            notificationId: challengeId,
            response: userResponse,
          }),
        });
        let data = await response.json();
        data = parseResponseBody(data);
        if (
          response.status === 200 &&
          (data.statusCode === 200 || data.statusCode === 201)
        ) {
          toast.success(
            userResponse
              ? "Challenge Accepted Successfully"
              : "Challenge Rejected Successfully"
          );

          // Track challenge_accepted or challenge_rejected activity (fire and forget)
          const activityType = userResponse
            ? ACTIVITY_TYPES.CHALLENGE_ACCEPTED
            : ACTIVITY_TYPES.CHALLENGE_REJECTED;
          const eventId = item?.eventId || item?.details?.eventID || challengeId;
          if (eventId) {
            console.log(`🎯 Tracking ${activityType} for eventId:`, eventId);
            storeUserActivity(accessToken, eventId, activityType)
              .then((result) => {
                if (result.success) {
                  console.log(`✅ ${activityType} activity tracked:`, result.activityId);
                } else {
                  console.warn(`⚠️ Failed to track ${activityType}:`, result.error);
                }
              })
              .catch((err) => console.warn(`❌ Error tracking ${activityType}:`, err));
          }

          // Update the notification status in local state
          if (updateNotificationStatus) {
            updateNotificationStatus(challengeId, {
              actionStatus: userResponse ? "accepted" : "rejected"
            });
          }

          const { body } = data;
          const { notificationId, senderId } = body;
          setUpdateNotification({
            challengeId: item?.notificationId,
            response: userResponse,
          });
          await sendNotification(senderId, notificationId);
          if (userResponse) {
            await fetchStatus();
            setShowAcceptModal(true);
            handleProfileUpdate();
          }
        } else if (data.statusCode === 400) {
          setCornfirmPurchaseBeltModal(true);
        } else {
          try {
            const parsedData = JSON.parse(data.body);
            toast.error(parsedData.message || "An error occurred");
          } catch {
            toast.error(data.body);
          }
        }
      } catch (error) {
        toast.error("Failed to respond to challenge");
      } finally {
        setAcceptLoader(false);
      }
    },
    [
      accessToken,
      sendNotification,
      setUpdateNotification,
      handleProfileUpdate,
      setShowAcceptModal,
      setCornfirmPurchaseBeltModal,
      fetchStatus,
      updateNotificationStatus,
    ]
  );

  const callGetChallengeDetails = useCallback(
    async (notificationId: string) => {
      try {
        const response = await getNotificationById(accessToken, notificationId);
        if (response.statusCode === 200) {
          setChallengeDetails(response.body.notification);
        } else {
          toast.error("Failed to fetch challenge details");
        }
      } catch (error) {
        toast.error("Failed to fetch challenge details");
      }
    },
    [accessToken, setChallengeDetails]
  );

  const getButtonStyle = useCallback(
    (baseStyle: Partial<ViewStyle> = {}): StyleProp<ViewStyle> => ({
      position: "relative" as const,
      borderRadius: 10,
      height:
        NOTIFICATION_DIMENSIONS.button.height[deviceSize] ||
        NOTIFICATION_DIMENSIONS.button.height.default,
      justifyContent: "center" as const,
      alignItems: "center" as const,
      shadowColor: "#000",
      shadowOffset: { width: 0, height: 2 },
      shadowOpacity: 0.25,
      shadowRadius: 3.84,
      elevation: 5,
      ...baseStyle,
    }),
    [deviceSize]
  );

  const getButtonTextStyle = useCallback(
    (color: string): StyleProp<TextStyle> => [
      {
        fontFamily: deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS
          ? "Anybody_600SemiBold"
          : "Anybody_700Bold",
        fontSize: deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS
          ? 6
          : 12,
        color: color || "#000000", // Default to black if no color provided
        textAlign: "center" as const,
        lineHeight:
          deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS
            ? 7
            : 16,
        alignSelf: "center" as const,
      },
    ],
    [deviceSize]
  );

  const ViewDetailsButton = useCallback(() => {
    // Hide View Details button for rejected challenges on Challenges tab (challenger side)
    if (
      selectedButton === "Challenges" &&
      item.actionStatus === "rejected" &&
      (item.actionType === "challenge_response" || item.actionType === "accept_reject")
    ) {
      return null;
    }

    const isViewDetailsOnly =
      item.actionStatus === "accepted" ||
      item.actionStatus === "checked_in" || // Added checked_in status
      item.actionStatus === "send" ||
      item.actionType === "event-reminder" ||
      item.actionType === "check-in-missed" ||
      item.actionType === "attendance-missed" ||
      item.actionType === "opponent-alert" ||
      item.actionType === "event-awarded" ||
      item.actionType === "account-warning" ||
      item.category === "cancelled" ||
      item.category === "completed" ||
      (item.actionType === "audience-alert" && item.actionStatus === "completed") || // Completed events
      item.notificationKey === "final-warning"; // Use notificationKey for final-warning

    const isGreenBackground = selectedButton === "I've Organised";
    const textColor = AppColors.white; // Always use white text

    const handlePress = () => {
      // Mark notification as seen when user clicks on it (non-blocking)
      handleMarkAsSeenAndRefreshCounts();

      // Check if this is a completed event (audience-alert with completed status)
      const isCompletedEvent = item.actionType === "audience-alert" && item.actionStatus === "completed";

      if (isCompletedEvent) {
        // Redirect to PastEvent screen for completed events
        navigateToScreen(navigation, AppScreens.PastEvent, {
          eventID: item.eventId,
        });
        return;
      }

      if (selectedButton === "I've Organised") {
        if (isViewDetailsOnly) {
          navigateToScreen(navigation, AppScreens.OnGoingEvents, {
            eventID: item.eventId,
          });
        } else if (item.actionStatus === "rejected") {
          navigateToScreen(navigation, AppScreens.OnGoingEvents, {
            eventID: item.eventId,
            tab: "Participant",
          });
        }
      } else if (
        selectedButton === "Challenges" &&
        item.actionType === "accept_reject" &&
        item.actionStatus === "pending"
      ) {
        setShowPendingNotifications(true);
        setChallengeItem({ ...item, popupTextColor: AppColors.gray_4E555F });
        setChallengeID(item.notificationId);
      } else if (selectedButton === "Challenges") {
        navigateToScreen(navigation, AppScreens.OnGoingEvents, { eventID: item.eventId });
      } else if (
        selectedButton === "Im Watching" &&
        item.category !== "cancelled"
      ) {
        navigateToScreen(navigation, AppScreens.GameShowScreen, {
          eventID: item.eventId,
        });
      } else {
        if (item.notificationKey === "final-warning") {
          setEventData(item);
          setFinalWarningPopUp(true);
        } else {
          navigateToScreen(navigation, AppScreens.OnGoingEvents, {
            eventID: item.eventId,
          });
        }
      }
    };

    return (
      <TouchableOpacity
        style={getButtonStyle({
          backgroundColor: isGreenBackground
            ? AppColors.appGreenColor_51AF07
            : AppColors.black,
          width:
            selectedButton === "I've Organised"
              ? isViewDetailsOnly
                ? deviceSize === DEVICE_SIZES.SM ||
                  deviceSize === DEVICE_SIZES.XS
                  ? 50
                  : 120
                : deviceSize === DEVICE_SIZES.SM ||
                  deviceSize === DEVICE_SIZES.XS
                  ? 96
                  : 200
              : deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS
                ? selectedButton === "Challenges" ||
                  selectedButton === "Im Watching"
                  ? 47
                  : 70
                : selectedButton === "Challenges" ||
                  selectedButton === "Im Watching"
                  ? 110
                  : 157,
          borderWidth:
            selectedButton === "Challenges" || selectedButton === "Im Watching"
              ? 1
              : undefined,
          borderColor:
            selectedButton === "Challenges" || selectedButton === "Im Watching"
              ? AppColors.white
              : undefined,
        })}
        onPress={handlePress}
      >
        <Text style={getButtonTextStyle(textColor)}>
          {selectedButton === "I've Organised" && !isViewDetailsOnly
            ? NOTIFICATION_STRINGS.INVITE_ANOTHER_OPPONENT
            : NOTIFICATION_STRINGS.VIEW_DETAILS}
        </Text>
      </TouchableOpacity>
    );
  }, [
    selectedButton,
    item,
    navigation,
    setShowPendingNotifications,
    setChallengeItem,
    setChallengeID,
    deviceSize,
    getButtonStyle,
    getButtonTextStyle,
  ]);

  const ViewUpdateEventPopUpsButton = useCallback(
    () => (
      <TouchableOpacity
        disabled={
          // Only disable for event_update (not event_update_before)
          (item.actionType === "event_update" &&
            item.type !== "event_update_before" &&
            item.actionStatus !== "pending") ||
          showChangesLoader
        }
        style={getButtonStyle({
          backgroundColor: AppColors.black,
          borderWidth: 1,
          borderColor: AppColors.white,
          width:
            deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS
              ? 50
              : 120,
          opacity:
            // Only reduce opacity for event_update (not event_update_before)
            (item.actionType === "event_update" &&
              item.type !== "event_update_before" &&
              item.actionStatus !== "pending") ||
              showChangesLoader
              ? 0.5
              : 1,
        })}
        onPress={() => {
          // Mark notification as seen when user clicks on it (non-blocking)
          handleMarkAsSeenAndRefreshCounts();

          if (item.actionType === "event_update_before" || item.type === "event_update_before") {
            // Navigate to event details page (before challenge accepted)
            navigateToScreen(navigation, AppScreens.OnGoingEvents, {
              eventID: item.eventId,
            });
          } else if (item.actionType === "event_update") {
            // Show modal for accept/reject changes (after challenge accepted)
            setPreviousEventDetails(item.details);
            setUpdatedEventEventId(item.eventId);
            setUpdatedEventDetails(item.updatedEventDetails);
            setUpdatedEventNotificationId(item.notificationId);
            setShowEventsDetailsUpdatedModal(true);
          } else if (item.actionType === "event_update_status") {
            setUpdatedEventEventId(item.details.eventID);
            item.actionStatus === "accepted"
              ? setShowChangesApprovedModal(true)
              : setShowChangesRejectedModal(true);
          }
        }}
      >
        <Text style={getButtonTextStyle(AppColors.white)}>
          {NOTIFICATION_STRINGS.VIEW_DETAILS}
        </Text>
      </TouchableOpacity>
    ),
    [
      item,
      showChangesLoader,
      setPreviousEventDetails,
      setUpdatedEventEventId,
      setUpdatedEventDetails,
      setUpdatedEventNotificationId,
      setShowEventsDetailsUpdatedModal,
      setShowChangesApprovedModal,
      setShowChangesRejectedModal,
      deviceSize,
      getButtonStyle,
      getButtonTextStyle,
    ]
  );

  const ViewConfirmAttendanceButton = useCallback(() => {
    const isOrganizer = item?.details?.organiserId === currentUser;
    const isChallenger = item?.details?.challengerId === currentUser;
    const isCheckedIn =
      (isOrganizer && item.details.checkInStatus?.organiser) ||
      (isChallenger && item.details.checkInStatus?.challenger);
    const isCheckInPending =
      (isOrganizer && !item.details.checkInStatus?.organiser) ||
      (isChallenger && !item.details.checkInStatus?.challenger);

    const attendanceConfirmed =
      (isOrganizer && item.details.attendanceStatus?.organiser) ||
      (isChallenger && item.details.attendanceStatus?.challenger);

    return (
      <>
        {/* Handle all reminder notifications (3h, 6h, 12h, 24h) */}
        {(isOrganizer || isChallenger) &&
          item.actionType === "attendance-reminder" &&
          (item.notificationKey === "reminder-3h" ||
            item.notificationKey === "reminder-6h" ||
            item.notificationKey === "reminder-12h" ||
            item.notificationKey === "reminder-24h") && (
            <>
              {!attendanceConfirmed && (
                <CommonButton
                  disabled={
                    noTimeLeft ||
                    confirmCheckInLoader ||
                    item.actionStatus === "confirmed" ||
                    isMissed
                  }
                  disabledCustomStyle={{ opacity: 0.5 }}
                  title={
                    isMissed
                      ? "Missed Confirmation"
                      : item.actionStatus === "confirmed"
                        ? NOTIFICATION_STRINGS.ATTENDANCE_CONFIRMED
                        : NOTIFICATION_STRINGS.CONFIRM
                  }
                  onTap={() => {
                    if (!isMissed && item.actionStatus !== "confirmed") {
                      // Mark notification as seen when user interacts with it (non-blocking)
                      handleMarkAsSeenAndRefreshCounts();
                      confirmEventCheckInStatus(
                        item.eventId,
                        item.notificationId
                      );
                    }
                  }}
                  buttonStyle={{
                    paddingVertical:
                      NOTIFICATION_DIMENSIONS.button.padding[deviceSize]
                        ?.vertical ||
                      NOTIFICATION_DIMENSIONS.button.padding.default.vertical,
                    paddingHorizontal:
                      NOTIFICATION_DIMENSIONS.button.padding[deviceSize]
                        ?.horizontal ||
                      NOTIFICATION_DIMENSIONS.button.padding.default.horizontal,
                    backgroundColor: isMissed
                      ? AppColors.red_AF0707
                      : item.actionStatus === "confirmed"
                        ? AppColors.appGreenColor_51AF07
                        : AppColors.appViolentColor_6D08C3,
                    borderRadius: 10,
                    shadowOpacity: 0,
                    height:
                      NOTIFICATION_DIMENSIONS.button.height[deviceSize] ||
                      NOTIFICATION_DIMENSIONS.button.height.default,
                  }}
                  fontStyle={
                    deviceSize === DEVICE_SIZES.SM ||
                      deviceSize === DEVICE_SIZES.XS
                      ? AppFontStyle.BOLD_ANYBODY_6
                      : AppFontStyle.BOLD_ANYBODY_12
                  }
                />
              )}
              <TouchableOpacity
                disabled={confirmCheckInLoader}
                style={getButtonStyle({
                  backgroundColor: AppColors.black,
                  borderWidth: 1,
                  borderColor: AppColors.white,
                  height:
                    deviceSize === DEVICE_SIZES.SM ||
                      deviceSize === DEVICE_SIZES.XS
                      ? 15
                      : 35,
                  paddingVertical:
                    deviceSize === DEVICE_SIZES.SM ||
                      deviceSize === DEVICE_SIZES.XS
                      ? 5
                      : 10,
                  paddingHorizontal:
                    deviceSize === DEVICE_SIZES.SM ||
                      deviceSize === DEVICE_SIZES.XS
                      ? 8
                      : 14,
                  opacity: confirmCheckInLoader ? 0.5 : 1,
                })}
                onPress={() =>
                  navigateToScreen(navigation, AppScreens.OnGoingEvents, {
                    eventID: item.eventId,
                  })
                }
              >
                <Text
                  style={[
                    {
                      fontFamily: deviceSize === DEVICE_SIZES.SM ||
                        deviceSize === DEVICE_SIZES.XS
                        ? "Anybody_700Bold"
                        : "Anybody_700Bold",
                      fontSize: deviceSize === DEVICE_SIZES.SM ||
                        deviceSize === DEVICE_SIZES.XS
                        ? 6
                        : 12,
                      color: AppColors.white,
                      textAlign: "center" as const,
                    },
                  ]}
                >
                  {NOTIFICATION_STRINGS.VIEW_EVENT_DETAILS}
                </Text>
              </TouchableOpacity>
            </>
          )}

        {/* Handle 1h reminder */}
        {(isOrganizer || isChallenger) &&
          item.actionType === "attendance-reminder" &&
          item.notificationKey === "reminder-1h" && (
            <>
              {!attendanceConfirmed && (
                <CommonButton
                  disabled={
                    noTimeLeft ||
                    confirmCheckInLoader ||
                    item.actionStatus === "confirmed" ||
                    isMissed
                  }
                  disabledCustomStyle={{ opacity: 0.5 }}
                  title={
                    isMissed
                      ? "Missed Confirmation"
                      : item.actionStatus === "confirmed"
                        ? NOTIFICATION_STRINGS.ATTENDANCE_CONFIRMED
                        : NOTIFICATION_STRINGS.CONFIRM
                  }
                  onTap={() => {
                    if (!isMissed && item.actionStatus !== "confirmed") {
                      // Mark notification as seen when user interacts with it (non-blocking)
                      handleMarkAsSeenAndRefreshCounts();
                      confirmEventCheckInStatus(
                        item.eventId,
                        item.notificationId
                      );
                    }
                  }}
                  buttonStyle={{
                    paddingVertical:
                      deviceSize === DEVICE_SIZES.SM ||
                        deviceSize === DEVICE_SIZES.XS
                        ? 0
                        : 10,
                    paddingHorizontal:
                      deviceSize === DEVICE_SIZES.SM ||
                        deviceSize === DEVICE_SIZES.XS
                        ? 8
                        : 14,
                    backgroundColor: isMissed
                      ? AppColors.red_AF0707
                      : item.actionStatus === "confirmed"
                        ? AppColors.appGreenColor_51AF07
                        : AppColors.appViolentColor_6D08C3,
                    borderRadius: 10,
                    shadowOpacity: 0,
                    height:
                      deviceSize === DEVICE_SIZES.SM ||
                        deviceSize === DEVICE_SIZES.XS
                        ? 15
                        : 35,
                  }}
                  fontStyle={
                    deviceSize === DEVICE_SIZES.SM ||
                      deviceSize === DEVICE_SIZES.XS
                      ? AppFontStyle.BOLD_ANYBODY_6
                      : AppFontStyle.BOLD_ANYBODY_12
                  }
                />
              )}
              <TouchableOpacity
                disabled={confirmCheckInLoader}
                style={getButtonStyle({
                  backgroundColor: AppColors.black,
                  height:
                    deviceSize === DEVICE_SIZES.SM ||
                      deviceSize === DEVICE_SIZES.XS
                      ? 15
                      : 35,
                  paddingVertical:
                    deviceSize === DEVICE_SIZES.SM ||
                      deviceSize === DEVICE_SIZES.XS
                      ? 5
                      : 10,
                  paddingHorizontal:
                    deviceSize === DEVICE_SIZES.SM ||
                      deviceSize === DEVICE_SIZES.XS
                      ? 8
                      : 14,
                  opacity: confirmCheckInLoader ? 0.5 : 1,
                })}
                onPress={() =>
                  navigateToScreen(navigation, AppScreens.OnGoingEvents, {
                    eventID: item.eventId,
                  })
                }
              >
                <Text
                  style={[
                    {
                      fontFamily: deviceSize === DEVICE_SIZES.SM ||
                        deviceSize === DEVICE_SIZES.XS
                        ? "Anybody_700Bold"
                        : "Anybody_700Bold",
                      fontSize: deviceSize === DEVICE_SIZES.SM ||
                        deviceSize === DEVICE_SIZES.XS
                        ? 6
                        : 12,
                      color: AppColors.white,
                      textAlign: "center" as const,
                    },
                  ]}
                >
                  {NOTIFICATION_STRINGS.VIEW_EVENT_DETAILS}
                </Text>
              </TouchableOpacity>
            </>
          )}

        {/* Handle final warning */}
        {(isOrganizer || isChallenger) &&
          item.actionType === "attendance-reminder" &&
          item.notificationKey === "final-warning" && (
            <TouchableOpacity
              disabled={confirmCheckInLoader || isCheckedIn}
              style={getButtonStyle({
                backgroundColor: isCheckedIn
                  ? AppColors.appGreenColor_51AF07
                  : AppColors.black,
                borderWidth: isCheckedIn ? 0 : 1,
                borderColor: isCheckedIn ? undefined : AppColors.white,
                height:
                  deviceSize === DEVICE_SIZES.SM ||
                    deviceSize === DEVICE_SIZES.XS
                    ? 15
                    : 35,
                paddingVertical:
                  deviceSize === DEVICE_SIZES.SM ||
                    deviceSize === DEVICE_SIZES.XS
                    ? 5
                    : 10,
                paddingHorizontal:
                  deviceSize === DEVICE_SIZES.SM ||
                    deviceSize === DEVICE_SIZES.XS
                    ? 8
                    : 14,
                opacity: confirmCheckInLoader || isCheckedIn ? 0.5 : 1,
              })}
              onPress={() => {
                if (!isCheckedIn) {
                  // Mark notification as seen when user interacts with it (non-blocking)
                  handleMarkAsSeenAndRefreshCounts();
                  setEventData(item);
                  setFinalWarningPopUp(true);
                }
              }}
            >
              <Text
                style={[
                  {
                    fontFamily: deviceSize === DEVICE_SIZES.SM ||
                      deviceSize === DEVICE_SIZES.XS
                      ? "Anybody_700Bold"
                      : "Anybody_700Bold",
                    fontSize: deviceSize === DEVICE_SIZES.SM ||
                      deviceSize === DEVICE_SIZES.XS
                      ? 6
                      : 12,
                    color: AppColors.white,
                    textAlign: "center" as const,
                  },
                ]}
              >
                {isCheckedIn
                  ? "Checked In Successfully"
                  : NOTIFICATION_STRINGS.VIEW_DETAILS}
              </Text>
            </TouchableOpacity>
          )}
      </>
    );
  }, [
    item,
    currentUser,
    noTimeLeft,
    confirmCheckInLoader,
    confirmEventCheckInStatus,
    navigation,
    deviceSize,
    getButtonStyle,
    getButtonTextStyle,
    isMissed,
  ]);

  const ChatButton = useCallback(
    () => (
      <TouchableOpacity
        style={getButtonStyle({
          height:
            deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS
              ? 17.5
              : 30,
          width:
            deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS
              ? 15.5
              : 30,
        })}
        onPress={() =>
          navigateToScreen(navigation, AppScreens.OnGoingEvents, {
            eventID: item.eventId,
            tab: "Chat",
          })
        }
      >
        {unreadMessages > 0 && (
          <View
            style={{
              position: "absolute" as const,
              right: -5,
              top: -5,
              backgroundColor: AppColors.red_EA3737,
              borderRadius: 12,
              height:
                deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS
                  ? 10
                  : 19,
              width:
                deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS
                  ? 10
                  : 19,
              justifyContent: "center" as const,
              alignItems: "center" as const,
              zIndex: 10,
            }}
          >
            <Text
              style={{
                color: AppColors.white,
                fontSize:
                  deviceSize === DEVICE_SIZES.SM ||
                    deviceSize === DEVICE_SIZES.XS
                    ? 6
                    : 12,
                textAlign: "center" as const,
              }}
            >
              {unreadMessages}
            </Text>
          </View>
        )}
        <Image
          resizeMode="contain"
          source={AppImages.icChatWhite}
          style={{
            height:
              deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS
                ? 15.5
                : 30,
            width:
              deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS
                ? 15.5
                : 30,
          }}
        />
      </TouchableOpacity>
    ),
    [unreadMessages, navigation, deviceSize, getButtonStyle]
  );

  const MissedConfirmationButton = useCallback(
    () => (
      <CommonButton
        disabled={true}
        title={"Missed Confirmation"}
        buttonStyle={{
          paddingVertical:
            deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS
              ? 0
              : 10,
          paddingHorizontal:
            deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS
              ? 8
              : 14,
          backgroundColor: AppColors.red_AF0707,
          borderRadius: 10,
          shadowOpacity: 0,
          height:
            deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS
              ? 15
              : 35,
        }}
        fontStyle={
          deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS
            ? AppFontStyle.BOLD_ANYBODY_6
            : AppFontStyle.BOLD_ANYBODY_12
        }
      />
    ),
    [deviceSize]
  );

  const renderButtons = () => {
    switch (selectedButton) {
      case "I've Organised":
        // Handle completed check-ins first (actionStatus: "checked_in")
        if (
          (item.actionType === "challenger_check_in" ||
            item.actionType === "organiser_check_in") &&
          item.actionStatus === "checked_in"
        ) {
          return <ViewDetailsButton />;
        }

        if (
          item.actionType === "check-in" ||
          item.actionType === "attendance-reminder" ||
          item.actionType === "challenger_check_in" ||
          item.actionType === "organiser_check_in" ||
          item.notificationKey === "final-warning" ||
          item.notificationKey === "reminder-1h" ||
          item.notificationKey === "reminder-3h" || // Added reminder-3h
          item.notificationKey === "reminder-6h" || // Added reminder-6h
          item.notificationKey === "reminder-12h" || // Added reminder-12h
          item.notificationKey === "reminder-24h" // Added reminder-24h
        ) {
          return <ViewConfirmAttendanceButton />;
        }
        if (
          item.actionType === "event_update_status" ||
          item.actionType === "event_update" ||
          item.actionType === "event_update_before"
        ) {
          return <ViewUpdateEventPopUpsButton />;
        }
        if (
          [
            "attendance-missed",
            "check-in-missed",
            "opponent-alert",
            "event-awarded",
            "account-warning",
          ].includes(item.actionType)
        ) {
          return (
            <>
              {["attendance-missed", "check-in-missed"].includes(
                item.actionType
              ) && <MissedConfirmationButton />}
              <ViewDetailsButton />
            </>
          );
        }
        // Handle event reminders and other notification types
        if (
          item.actionType === "event-reminder" ||
          item.actionType === "challenge_request" ||
          item.actionType === "challenge_response" ||
          item.actionType === "audience-alert" ||  // Handle completed events
          item.category === "completed" ||
          item.category === "cancelled"
        ) {
          return <ViewDetailsButton />;
        }
        // Fallback for any other notification types
        return <ViewDetailsButton />;

      case "Challenges":
        // Handle completed check-ins first (actionStatus: "checked_in")
        if (
          (item.actionType === "challenger_check_in" ||
            item.actionType === "organiser_check_in") &&
          item.actionStatus === "checked_in"
        ) {
          return <ViewDetailsButton />;
        }

        if (
          item.actionType === "check-in" ||
          item.actionType === "attendance-reminder" ||
          item.actionType === "challenger_check_in" ||
          item.actionType === "organiser_check_in" ||
          item.notificationKey === "final-warning" || // Added for final-warning
          item.notificationKey === "reminder-1h" ||
          item.notificationKey === "reminder-3h" || // Added reminder-3h
          item.notificationKey === "reminder-6h" || // Added reminder-6h
          item.notificationKey === "reminder-12h" || // Added reminder-12h
          item.notificationKey === "reminder-24h" // Added reminder-24h
        ) {
          return <ViewConfirmAttendanceButton />;
        }
        if (
          [
            "attendance-missed",
            "check-in-missed",
            "opponent-alert",
            "event-awarded",
            "account-warning",
          ].includes(item.actionType)
        ) {
          return (
            <>
              {["attendance-missed", "check-in-missed"].includes(
                item.actionType
              ) && <MissedConfirmationButton />}
              <ViewDetailsButton />
            </>
          );
        }

        // Handle accept/reject challenges
        if (item.actionType === "accept_reject") {
          return (
            <>
              {item.actionStatus !== "rejected" && (
                <TouchableOpacity
                  style={getButtonStyle({
                    backgroundColor: AppColors.appGreenColor_51AF07,
                    width:
                      deviceSize === DEVICE_SIZES.SM ||
                        deviceSize === DEVICE_SIZES.XS
                        ? item.actionStatus === "accepted"
                          ? 75
                          : 86
                        : item.actionStatus === "accepted"
                          ? 150
                          : 152,
                    opacity: item.actionStatus === "accepted" ? 0.7 : 1,
                  })}
                  onPress={() => {
                    if (item.actionStatus !== "accepted") {
                      // Mark notification as seen when user interacts with it (non-blocking)
                      handleMarkAsSeenAndRefreshCounts();
                      handleAcceptPress(true, item.notificationId);
                      setChallengeItem(item);
                      setChallengeID(item.notificationId);
                    }
                  }}
                >
                  <Text style={getButtonTextStyle(AppColors.white)}>
                    {item.actionStatus === "accepted"
                      ? NOTIFICATION_STRINGS.CHALLENGE_ACCEPTED
                      : NOTIFICATION_STRINGS.ACCEPT_CHALLENGE}
                  </Text>
                </TouchableOpacity>
              )}
              {item.actionStatus !== "accepted" && (
                <TouchableOpacity
                  style={getButtonStyle({
                    backgroundColor: AppColors.red_EA3737,
                    width:
                      deviceSize === DEVICE_SIZES.SM ||
                        deviceSize === DEVICE_SIZES.XS
                        ? 66
                        : 152,
                    opacity: item.actionStatus === "rejected" ? 0.7 : 1,
                  })}
                  onPress={() => {
                    if (item.actionStatus !== "rejected") {
                      // Mark notification as seen when user interacts with it (non-blocking)
                      handleMarkAsSeenAndRefreshCounts();
                      handleAcceptPress(false, item.notificationId);
                      setChallengeItem(item);
                      setChallengeID(item.notificationId);
                    }
                  }}
                >
                  <Text style={getButtonTextStyle(AppColors.white)}>
                    {item.actionStatus === "rejected"
                      ? NOTIFICATION_STRINGS.CHALLENGE_REJECTED
                      : NOTIFICATION_STRINGS.REJECT_CHALLENGE}
                  </Text>
                </TouchableOpacity>
              )}
              <ViewDetailsButton />
              {(item.actionStatus === "accepted" ||
                item.actionType === "chat") && <ChatButton />}
            </>
          );
        }

        // Handle event updates
        if (
          item.actionType === "event_update" ||
          item.actionType === "event_update_status" ||
          item.actionType === "event_update_before"
        ) {
          return <ViewUpdateEventPopUpsButton />;
        }

        // Handle event reminders and other challenge-related notifications
        if (
          item.actionType === "event-reminder" ||
          item.actionType === "challenge_request" ||
          item.actionType === "challenge_response" ||
          item.actionType === "audience-alert" ||  // Handle completed events
          item.category === "completed" ||
          item.category === "cancelled"
        ) {
          return <ViewDetailsButton />;
        }

        // Fallback for any other challenge notification types
        return <ViewDetailsButton />;

      case "Im Watching":
        // Handle audience alerts
        if (item.actionType === "audience-alert") {
          return <ViewDetailsButton />;
        }

        if (
          item.category !== "cancelled" &&
          item.actionType !== "audience-alert"
        ) {
          return (
            <TouchableOpacity
              style={getButtonStyle({
                backgroundColor: AppColors.appGreenColor_51AF07,
                width:
                  deviceSize === DEVICE_SIZES.SM ||
                    deviceSize === DEVICE_SIZES.XS
                    ? 67
                    : 152,
              })}
              onPress={() => {
                // Mark notification as seen when user interacts with it (non-blocking)
                handleMarkAsSeenAndRefreshCounts();
                navigateToScreen(navigation, AppScreens.GameShowScreen, {
                  eventID: item.eventId,
                });
              }}
            >
              <Text style={getButtonTextStyle(AppColors.white)}>
                {NOTIFICATION_STRINGS.OPEN_EVENT_PAGE}
              </Text>
            </TouchableOpacity>
          );
        }

        // Fallback for cancelled events or other scenarios
        return <ViewDetailsButton />;

      default:
        // Always provide a fallback View Details button
        return <ViewDetailsButton />;
    }
  };

  return (
    <>
      <View
        style={{
          flexDirection: "row" as const,
          gap:
            deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS
              ? 4
              : 10,
        }}
      >
        {renderButtons()}
      </View>
      {finalWarningPopUp && (
        <FinalWarning
          eventData={eventData}
          setShowModal={setFinalWarningPopUp}
          showModal={finalWarningPopUp}
          notificationId={eventData?.notificationId}
        />
      )}
    </>
  );
};
